import React from "react";
import Container from "../components/Container";
import HeaderBanner from "../components/HeaderBanner";
import useLocale from "../locales";
import { Helmet } from "react-helmet";
const PrivacyPolicy = () => {
  const { textData } = useLocale();
  const privacyPolicy = textData.privacyPolicy;
  const data = {
    header: "Privacy Policy",
    sections: [
      {
        type: "paragraph",
        content: privacyPolicy.intro,
      },
      {
        type: "title",
        content: privacyPolicy.informationWeCollect,
      },
      {
        type: "list",
        items: [
          {
            title: privacyPolicy.analyticsInfoTitle,
            description: privacyPolicy.analyticsInfoDesc,
          },
        ],
      },
      {
        type: "title",
        content: privacyPolicy.useOfInformation,
      },
      {
        type: "paragraph",
        content: privacyPolicy.useOfInformationDesc,
      },
      {
        type: "list",
        items: [
          {
            description: privacyPolicy.useOfInformationList[0],
          },
          {
            description: privacyPolicy.useOfInformationList[1],
          },
        ],
      },
      {
        type: "title",
        content: privacyPolicy.disclosureOfInformation,
      },
      {
        type: "paragraph",
        content: privacyPolicy.disclosureOfInformationDesc,
      },
      {
        type: "list",
        items: [
          {
            title: privacyPolicy.disclosureItems[0].title,
            description: privacyPolicy.disclosureItems[0].desc,
          },
          {
            title: privacyPolicy.disclosureItems[1].title,
            description: privacyPolicy.disclosureItems[1].desc,
          },
          {
            title: privacyPolicy.disclosureItems[2].title,
            description: privacyPolicy.disclosureItems[2].desc,
          },
        ],
      },
      {
        type: "title",
        content: privacyPolicy.cookiesTitle,
      },
      {
        type: "paragraph",
        content: privacyPolicy.cookiesDesc,
      },
      {
        type: "title",
        content: privacyPolicy.securityTitle,
      },
      {
        type: "paragraph",
        content: privacyPolicy.securityDesc,
      },
      {
        type: "title",
        content: privacyPolicy.childrenPolicyTitle,
      },
      {
        type: "paragraph",
        content: privacyPolicy.childrenPolicyDesc,
      },
      {
        type: "title",
        content: privacyPolicy.contactTitle,
      },
      {
        type: "paragraph",
        content: privacyPolicy.contactDesc,
      },
    ],
  };

  const renderSection = (section, index) => {
    switch (section.type) {
      case "paragraph":
        return (
          <p
            key={index}
            className="text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400"
            dangerouslySetInnerHTML={{ __html: section.content }}
          />
        );
      case "title":
        return (
          <h2
            key={index}
            className="text-gray-font sm:text-[17px] text-[16px] font-lato-medium-500 mt-[20px]"
          >
            {section.content}
          </h2>
        );
      case "list":
        return (
          <ul
            key={index}
            className="list-disc pl-[20px] text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400"
          >
            {section.items.map((item, i) => (
              <li key={i} className="">
                {item.title && (
                  <span className="font-lato-medium-500 text-[16px]">
                    {item.title}
                  </span>
                )}{" "}
                {item.description}
              </li>
            ))}
          </ul>
        );
      default:
        return null;
    }
  };
  return (
    <>
      <Helmet>
        <title>GrowLifeFund Privacy Policy | Your Data Protection Now</title>
        <meta
          name="description"
          content="GrowLifeFund protects your data with strict security measures. Learn how we collect and safeguard your information to ensure full transparency and trust."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://growlifefund.com/privacy-policy" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="GrowLifeFund Privacy Policy | Your Data Protection Now"
        />
        <meta
          property="og:description"
          content="GrowLifeFund protects your data with strict security measures. Learn how we collect and safeguard your information to ensure full transparency and trust."
        />
        <meta
          property="og:url"
          content="https://growlifefund.com/privacy-policy"
        />
        <meta property="og:site_name" content="growlifefund" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="GrowLifeFund privacy policy and data protection"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>
      <Container>
        <div className="my-[24px]">
          <HeaderBanner name={privacyPolicy.header} backUrl="/" />
          <div>
            {data.sections.map((section, index) =>
              renderSection(section, index)
            )}
          </div>
        </div>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
